export function DateToString(date: Date){
  return (
    date.getFullYear() +
    "-" +
    ("0" + (date.getMonth() + 1)).slice(-2) +
    "-" +
    ("0" + date.getDate()).slice(-2)
  );
}




export function ChangeTimezone(date: Date, timezone: string) {

  // suppose the date is 12:00 UTC
  let invdate = new Date(date.toLocaleString('en-US', {
    timeZone: timezone
  }));

  // then invdate will be 07:00 in Toronto
  // and the diff is 5 hours
  var diff = date.getTime() - invdate.getTime();

  // so 12:00 in Toronto is 17:00 UTC
  return new Date(date.getTime() - diff); // needs to substract

}
